import React, {useState} from "react";
import '../Messages/Messages.scss';
import MessagesData from "../Messages/MessagesData/MessagesData.js";
import MessageItem from "../Messages/MessageItem/MessageItem.js";
import { selectedCategoryOfMessages, selectIdOfMessage, clearIdMessage, updateReadMessage  } from "./messageslice.js";
import { chooseMessagesData1 } from "../../../helper/messageCategory.js";
import { getAllMessages } from "../../Authorization/authSlice.js";



const Messages = (props) => {
   
    const [dataMessage, setDataMessage] = useState({});
   // const [selectedId, setSelectedId] = useState();
  

    const {dispatch} = props;
  


    //HANDLE REFRESH MESSAGE
    const onHandlerRefreshMessage = () => {
        console.log('start refresh!')
        
        dispatch(getAllMessages(props.userId));
       

    }



    //HANDLE ONCLICK 
     const handleCategory = (e) => {

        const selectedCategory = Number(e.currentTarget.value);
        //console.log(selectedCategory);
       // console.log(e.currentTarget.value);
       // console.log(e.target.value);
        dispatch(selectedCategoryOfMessages(selectedCategory));
        dispatch(clearIdMessage());
        setDataMessage({});
        //setSelectedId();

       
       
    }

    //STYLE IF CHOOSE CATEGORY----dont see document.getElementById("inbox-1") if {styleChooseCategory}

/*
    let styleChooseCategory; 
    const but = document.getElementById("inbox-1");
    //const idSelected = buttonSelected.value;
    console.log(but);
   // console.log(idSelected);

    if (props.messagesData.selectedCategory === 1 ) {
        styleChooseCategory = 'menu-button-selected';
    } else {styleChooseCategory = 'menu-button'};

*/


    //CALCULATE UNREAD MESSAGES
    const calculateUnreadMessages = (data) => {
        let result = 0;
        if (data) {
            data.forEach(item => {
                if (!item.read) {
                    result ++;
                }
                
            });
        }
        
        return result;
    }
    const resultUnreadInboxMessages = calculateUnreadMessages(props.messagesData.messagesUserDataInbox);
    const resultUnreadAdminMessages = calculateUnreadMessages(props.messagesData.messagesDataAdmin);
    
    //STYLE UNREAD RESULT
    
    const unreadStyle = (result) => {
        let style; 
        if (result) {
            style = 'unread';
        } else {style = 'read'};
        return style;
    }
    const styleUnreadForInbox = unreadStyle(resultUnreadInboxMessages);     
    const styleUnreadForAdmin = unreadStyle(resultUnreadAdminMessages); 

    // CHOOSE SELECTED MESSAGE
    const selectedMessageDataId = (data, id) => {
      // const dataMessages = data;
     // console.log(data);
     // console.log(id);
       const result = data.find(item =>item.id === id);
      // console.log(result);
       return result;
    }

    //const selectedCategory = Number(props.messagesData.selectedCategory);
    //const selectedMessageId = Number(props.messagesData.selectedIdMessage);
    
    // GET TO STATE DATA MESSAGE
    const onHandlerClickMesssage = (selectedId) => {
        //setSelectedId(e);
        console.log('1.1.1.1.1 Start click mes handler');

        dispatch(selectIdOfMessage(selectedId));

        //CHOOSE CATEGORY MESSAGES DATA

        const selectedCategory = Number(props.messagesData.selectedCategory);

        //const selectedMessageId = props.messagesData.selectedIdMessage;
       // console.log(selectedCategory);
        //console.log(selectedMessageId);
        //console.log(typeof(selectedCategory));
        //console.log(props.messagesData.selectedIdMessage);

        const data = chooseMessagesData1(props.messagesData, selectedCategory); 

        console.log(data);
       // console.log(props.messagesData);
        // CHOOSE DATA MESSAGE

       const  messageData = selectedMessageDataId(data, selectedId);
       setDataMessage(messageData);
      //setSelectedId(selectedId);


   // READ MESSAGE -except send images
   const indexMessage = data.findIndex(item => item.id === selectedId);
   const readState = data[indexMessage].read;
   console.log(readState);
  
  //console.log(messageData.user.id);
    if(!readState && props.userId !== messageData.user.id) {
       
    console.log('Start update read message');
    dispatch(updateReadMessage(selectedId));
   }
   

    }




       //RENDER MENU MESSAGES
     /*  let styleMesMenuButton;
       if (e.target.value === props.messagesData.selectedCategory) {
        console.log(e.target.value);
        console.log(props.messagesData.selectedCategory);

           styleMesMenuButton ='menu-button-selected';
           
       } else {
               styleMesMenuButton ='menu-button';
             
       }
*/


   const renderMessagesMenu = () => {
    
 
    return (
        <div className="menu-messages">
            <ul>
                <li><button    className={props.messagesData.selectedCategory === 1 ? 'menu-button-selected' :'menu-button'} value='1' onClick={handleCategory}>Входящие  <span className={styleUnreadForInbox}>{resultUnreadInboxMessages}</span>/{props.messagesData.messagesUserDataInbox.length}</button></li>
                <li><button    className={props.messagesData.selectedCategory === 2 ? 'menu-button-selected' :'menu-button'} value='2' onClick={handleCategory}>Исходящие  {props.messagesData.messagesUserDataSend.length}</button></li>
                <li><button    className={props.messagesData.selectedCategory === 3 ? 'menu-button-selected' :'menu-button'} value='3' onClick={handleCategory}>WSCproject  <span className={styleUnreadForAdmin}>{resultUnreadAdminMessages}</span>/{props.messagesData.messagesDataAdmin.length}</button></li>
            </ul>
            
        </div>
        )    
   }

    //RENDER MESSAGE
    const renderMessageItem = () => {
       // console.log(props.messagesData.selectedIdMessage);
        if (props.messagesData.selectedIdMessage) {
            return (
                <MessageItem 
                 dataMessage = {dataMessage}
                 userId={props.userId}
                 dispatch = {dispatch}
                 dataNotes={props.dataNotes}
                />
            )
        }
         else return null;
    }


       const messagesView = props.messagesView;
    if (messagesView) {

        return (
            <div className="Messages">
                <p className="main-header">Сообщения</p>
                <p className="message-header">(сообщения автоматически удаляются после 30дней)</p>
                <p className="header">{props.messagesData.nameSelectedCategory}</p>
                <button className="refresh" onClick={onHandlerRefreshMessage}></button>
                
                <div>
                    <div className="container">
                        {renderMessagesMenu()}

                        <MessagesData
                        messagesView={props.messagesView}
                        messagesData={props.messagesData}
                        userId={props.userId}
                        dispatch = {dispatch}
                        onHandlerClickMesssage = {onHandlerClickMesssage}
                        messagesDataFromAuth = {props.authData.messages}
                        />
                        {renderMessageItem()}
                        
                    </div>
                </div>

            </div>
        );   
    } 
    
    
    
    else return null;
   
};
export default Messages;